/*
 * @Author: raincoat raincoat_zhow@163.com
 * @Date: 2024-04-16 20:01:54
 * @LastEditors: raincoat raincoat_zhow@163.com
 * @LastEditTime: 2024-04-20 09:52:44
 * @FilePath: \universex\src\api\shopping.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import request from "../utils/request";
import { stringify } from "qs";

// 登出
export const getTopImageData = () => {
  return request({
    method: "get",
    url: "/ip/public/list/banner",
  });
};
export const getSwipperData = () => {
  return request({
    method: "get",
    url: "/ip/public/list/ip",
  });
};
export const getListDetailData = (data) => {
  return request({
    method: "get",
    url: "/ip/public/list/goods",
    params: data,
  });
};
export const getProductDetail = (data) => {
  return request({
    method: "get",
    url: `/ip/public/detail/${data.goodsId}`,
  });
};

export const addCart = (data) => {
  return request({
    method: "post",
    url: `/cart`,
    data,
  });
};

export const getCartList = (data) => {
  return request({
    method: "post",
    url: `/cart/page/${data.page}/${data.size}`,
    data,
  });
};

export const handleCuntSumbit = (data) => {
  return request({
    method: "post",
    url: `/cart/count/${data.count}`,
    params: data,
  });
};

export const cartSelect = (data) => {
  return request({
    method: "post",
    url: `/cart/selected/${data.selected}`,
    params: data,
  });
};

export const cartDelete = (params) => {
  console.log(params);
  return request({
    method: "delete",
    url: `/cart`,
    params,
    paramsSerializer: function (params) {
      return stringify(params, { indices: false, allowDots: true });
    },
  });
};

export const JSCart = (data) => {
  return request({
    method: "post",
    url: `/order/settlement`,
    data,
  });
};

/** 立即购买结算（不经过购物车） */
export const JSCartDirect = (data) => {
  return request({
    method: "post",
    url: "/order/settlement/direct",
    data,
  });
};

export const createOrder = (data) => {
  return request({
    method: "post",
    url: `/order`,
    data,
  });
};

/** 立即购买创建订单（不经过购物车） */
export const createOrderDirect = (data) => {
  return request({
    method: "post",
    url: "/order/direct",
    data,
  });
};
/** 获取已开启的支付方式（与后台支付管理同步，关闭的渠道不返回） */
export const getPaymentChannels = () => {
  return request({
    method: "get",
    url: "/pay-order/channels",
  });
};

export const pay = (data) => {
  return request({
    method: "put",
    url: `/pay-order/submit`,
    data,
  });
};
export const getOrderDetail = (data) => {
  return request({
    method: "get",
    url: `/order/${data.id}`,
  });
};
export const getOrderPage = (params, data) => {
  return request({
    method: "post",
    url: `/order/page/${params.page}/${params.size}`,
    data,
  });
};
export const cancelOrder = (data) => {
  return request({
    method: "put",
    url: `/order/cancel/${data.id}`,
  });
};
export const receiveOrder = (data) => {
  return request({
    method: "put",
    url: `/order/receive/${data.id}`,
  });
};

/** 模拟支付成功（仅测试/联调），将订单从待付款改为待发货 */
export const mockPaymentSuccess = (data) => {
  return request({
    method: "post",
    url: "/pay-order/mock-success",
    data: { orderId: data.orderId ?? data.id },
  });
};
// 订单退款（售后申请）
export const applyRefund = (data) => {
  return request({
    method: "put",
    url: `/order/refund/${data.id}`,
    data: {
      refundReason: data.refundReason,
    },
  });
};
export const cancelSale = (data) => {
  return request({
    method: "delect",
    url: `/after/sale/cancel/${data.id}`,
  });
};
export const afterSale = (data) => {
  return request({
    method: "post",
    url: `/after/sale`,
    data,
  });
};
